export default "__VITE_ASSET__DO9sKOxD__"